function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgList = function SvgList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 15 13",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.9 3.5H14c.6 0 1 .5 1 1v.2c0 .5-.4.9-.9.9H.9c-.5 0-.9-.4-.9-.9v-.2c0-.5.4-1 .9-1M.9 0H14c.6 0 1 .4 1 .9V1c0 .6-.4 1-.9 1H.9C.4 2 0 1.6 0 1.1V.9C0 .4.4 0 .9 0m0 7.1H14c.6 0 1 .4 1 .9v.1c0 .5-.4.9-.9.9H.9c-.5.1-.9-.3-.9-.8V8c0-.5.4-.9.9-.9m0 3.9H14c.5 0 .9.4.9.9v.1c0 .5-.4.9-.9.9H.9c-.5.1-.9-.3-.9-.8V12c0-.6.4-1 .9-1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export default ForwardRef;